// extracted by mini-css-extract-plugin
export default {"GameScreen":"GameScreen_GameScreen__xcouI"};